import { twMerge } from "tailwind-merge";
import { ArtworkItemImage } from "./ArtworkItemImage";
import { ArtworkItemContent } from "./ArtworkItemContent";
import { ImageOrientation } from "@/api/nfts/types";
import { Image } from "@/shared/types";
import { User } from "@/api/users/types";
import { Marketplaces } from "../../Marketplace/constants";

export interface BaseProps {
  id: string;
  name: string;
  artist: User;
  swap?: boolean;
  artistVisible?: boolean;
  marketplace?: Marketplaces;
  blockchain?: string;
  price?: string;
  paymentErc20TokenAddress?: string;
}

export interface Props extends BaseProps {
  image: Image;
}

const ArtworkItem = ({ id, image, name, swap = false, ...props }: Props) => {
  return (
    <div
      className={twMerge(
        "relative flex flex-col sm:items-center sm:justify-center w-full gap-y-6 sm:gap-y-10 sm:px-12",
        `${
          image.orientation == ImageOrientation.Portrait
            ? "items-start justify-end"
            : "items-center"
        } ${
          image.orientation == ImageOrientation.Landscape
            ? "sm:flex-col"
            : swap
              ? "sm:flex-row"
              : "sm:flex-row-reverse"
        }`,
      )}
    >
      <ArtworkItemImage id={id} name={name} image={image} />
      <ArtworkItemContent
        id={id}
        name={name}
        imageOrientation={image.orientation}
        swap={swap}
        {...props}
      />
    </div>
  );
};

export default ArtworkItem;
